import { useGetOrganisationsQuery } from "../organisationsSlice";
import useHasAccess from "../../../hooks/useHasAccess";
import useRefresher from "../../../hooks/useRefresher";

const useOrganisations = () => {
  const hasAccess = useHasAccess({ apiCall: "organisations.GET" });
  const organisations = useGetOrganisationsQuery(null, { skip: !hasAccess });
  useRefresher(organisations);

  return { ...organisations, hasAccess };
};

export default useOrganisations;
